import script from "./UploadDrawDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadDrawDocument.vue?vue&type=script&setup=true&lang=js"

import "./UploadDrawDocument.vue?vue&type=style&index=0&id=ebd75cbc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd75cbc"]])

export default __exports__